import React from 'react';

import { Button, Modal } from 'antd';

import CustomCopyToClipboard from 'components/CustomCopyToClipboard';

interface IProps {
  open: boolean;
  productId?: number;
  product: any;
  url?: any;
  newUrl?: any;
  onClose: any;
}

const ChekoutBooster: React.FC<IProps> = ({ open, onClose, product }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={<span style={{ color: '#192542' }}>Acelerador de Checkout</span>}
      width={640}
      footer={
        <div className='text-right'>
          <Button onClick={onClose}>Fechar</Button>
        </div>
      }
    >
      Insira o script abaixo em sua página de vendas para que seja feito o pré carregamento do Checkout, dessa forma
      quando seu cliente clicar em comprar e for redirecionado para o checkout, o mesmo irá carregar bem mais rápido,
      aumentando a possibilidade de conversão.
      <div className='mt-4' />
      <CustomCopyToClipboard
        style={{ width: '100%', fontSize: 11 }}
        text={`<script>(function(d,c) {var i=c||'preload',u,ifw='PGlmcmFtZSB3aWR0aD0iMCIgaGVpZ2h0PSIwIiBzdHlsZT0icG9zaXRpb246IGFic29sdXRlO3RvcDotMTAwMHB4OyIgc3JjPSJodHRwczovL3N1bi5lZHV6ei5jb20vcGl4ZWwve2lkfSI+PC9pZnJhbWU+';d.write(atob(ifw).replace('{id}',i));})(document,${product.id});</script>`}
        disableUnderline={true}
      />
    </Modal>
  );
};

export default ChekoutBooster;
